import SubcategoryPage from '@/components/template/SubcategoryPage';

const SmolnatiDodatki = () => {
  const products = [
    {
      title: "Smolnata posoda Natura",
      imageSrc: "https://images.unsplash.com/photo-1632120399340-dd60f322e57e?auto=format&fit=crop&q=80",
      url: "/dodatki/smolnati/natura"
    },
    {
      title: "Smolnata vaza Organo",
      imageSrc: "https://images.unsplash.com/photo-1603204077167-2fa0397f591a?auto=format&fit=crop&q=80",
      url: "/dodatki/smolnati/organo"
    },
    {
      title: "Smolnati podstavki Sereno",
      imageSrc: "https://images.unsplash.com/photo-1584589167171-541ce45f1eea?auto=format&fit=crop&q=80",
      url: "/dodatki/smolnati/sereno"
    },
    {
      title: "Okrasne skulpture Fluido",
      imageSrc: "https://images.unsplash.com/photo-1634712282287-14ed57b9cc89?auto=format&fit=crop&q=80",
      url: "/dodatki/smolnati/fluido"
    }
  ];

  return (
    <SubcategoryPage
      title="Smolnati dodatki"
      description="Edinstveni ročno izdelani dodatki iz naravne smole, ki dodajo vašemu prostoru elegantno in sodobno podobo."
      heroImage="https://images.unsplash.com/photo-1632120399340-dd60f322e57e?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default SmolnatiDodatki;